const styles = theme => ({
    root: {
        width: "100%",
        padding: theme.spacing.unit * 2
    },
    button: {
        margin: theme.spacing.unit,
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: "33.33%",
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    card: {
        maxWidth: 345,
    },
    media: {
        height: 500,
        paddingTop: "56.25%", // 16:9
        paddingBottom: "56.25%", // 16:9
        maxWidth: "100%"
    },
    gridList: {
        width: 500,
        height: 450,
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
    rightIcon: {
        marginLeft: theme.spacing.unit,
    },
    iconSmall: {
        fontSize: 20,
    },
    typography: {
        useNextVariants: true,
    },
    loadingCenter: {
        textAlign: "center"
    }
});

export default styles;